export enum OnboardingQueryTagTypes {
  CLASSES = 'Classes',
}
